import { Injectable } from '@angular/core';
import { stringToNumber } from '../codeUtils';
import { ConfigService } from '../config/config.service';
import { WebservicesService } from '../webservices/webservices.service';

@Injectable({
  providedIn: 'root'
})
export class JackpotService {

  private jackpotData: any[];

  constructor(
    private readonly config: ConfigService,
    private readonly webservices: WebservicesService,
  ) { }

  private getJackpotData(): Promise<any> {
    return this.webservices.get('games/get-jackpot').toPromise();
  }

  public async fetchJackpotData(): Promise<void> {
    // if (this.jackpotData) {
    //   return Promise.resolve();
    // }

    try {
      const data = await this.getJackpotData();
      if (data && data?.result === 1 && data?.payload && data?.payload?.jackpotList) {
        this.jackpotData = data?.payload?.jackpotList;
      } else {
        console.error('Failed to fetch jackpot data');
      }
    } catch (error) {
      console.error('Error fetching jackpot data:', error);
    }
  }

  public filteredJackpotData(gameTypeIdsToFilter: number): any[] {
    return this.jackpotData.filter(jackpotItem => {
      return jackpotItem.gameTypeIds.includes(gameTypeIdsToFilter);
    });
  }

  public groupJackpotDataByGameTypeIds(): { [key: number]: any[] } {
    const groupedData: { [key: number]: any[] } = {};

    if (this.jackpotData) {
      this.jackpotData.forEach(jackpotItem => {
        const gameTypeIds = jackpotItem.gameTypeIds[0];
        if (groupedData[gameTypeIds]) {
          groupedData[gameTypeIds].push(jackpotItem);
        } else {
          groupedData[gameTypeIds] = [jackpotItem];
        }
      });
    }

    return groupedData;
  }

  public async filteredJackpots(key: number): Promise<any[]> {
    await this.fetchJackpotData();

    const sortedData = this.sortedData(key);
    const maxJackpots: number = stringToNumber(this.config?.getConfig().FEATURE_MAX_JACKPOT_ALLOWED) ?? 4;
    return sortedData?.slice(0, maxJackpots);
  }

  private sortedData(key: number): any {
    const jackpots = this.groupJackpotDataByGameTypeIds()[key];

    if (jackpots) {
      jackpots.sort((a, b) => b.jackpotId - a.jackpotId);
    }

    return jackpots;
  }
}
